import { render, staticRenderFns } from "./indexTopInfo.vue?vue&type=template&id=fdeefe4a&scoped=true&"
import script from "./indexTopInfo.vue?vue&type=script&lang=js&"
export * from "./indexTopInfo.vue?vue&type=script&lang=js&"
import style0 from "./indexTopInfo.vue?vue&type=style&index=0&id=fdeefe4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdeefe4a",
  null
  
)

export default component.exports